import React from 'react';
import { useIntl } from 'react-intl';
import { mapInvoiceStreamName } from '@/shared/services/ObjectDisplayService';
import messages from './FieldMessages';
import RenderProperty from './RenderProperty';

export const getInvoiceStreamName = (value, intl, defaultName) => {
  if (!value) return '';
  // Fix casing of properties
  const {
    assignmentId,
    assignmentName,
    assignmentTemplateId,
    AssignmentId,
    AssignmentName,
    AssignmentTemplateId,
    assignmentTemplateName,
    AssignmentTemplateName,
  } = value;
  const stream = {
    assignmentId: assignmentId ?? AssignmentId,
    assignmentName: assignmentName ?? AssignmentName,
    assignmentTemplateId: assignmentTemplateId ?? AssignmentTemplateId,
    assignmentTemplateName: assignmentTemplateName ?? AssignmentTemplateName,
  };

  return mapInvoiceStreamName(stream, intl, defaultName);
};

const InvoiceStreamChange = props => {
  const intl = useIntl();
  const { log } = props;

  if (log.oldValue === null) {
    return (
      <span>
        {intl.formatMessage(messages.AddedAssignment, {
          property: RenderProperty({ intl, log }),
          name: getInvoiceStreamName(log.newValue, intl),
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.DeletedAssignment, {
        property: RenderProperty({ intl, log }),
        name: getInvoiceStreamName(log.oldValue, intl),
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default InvoiceStreamChange;
